<template>
    <div class="col-lg-12">
        <div class="col-md-12">
            <h1 class="mb-3">Receipt Log Units</h1>
        </div>
        <div class="col-md-12">
            <div class="d-flex">
                <p class="mr-3">Show <b>In Stock</b> units only</p>
                <base-switch
                    id="showInStockOnly"
                    v-model="inStockOnly"
                    type="primary"
                    on-text="Yes"
                    off-text="No"
                />
            </div>
        </div>
        <table-search-and-pagination
            :per-page="perPage"
            :current-page="currentPage"
            :table-data="receiptLogUnits"
            :query="routeQuery"
            @dataUpdated="queriedData = $event"
            @queryUpdated="$emit('search', $event)"
            @perPageUpdated="$emit('perPageUpdated', $event)"
        >
            <div slot="header" class="mb-3">
                <div class="flex-between">
                    <h3 class="card-title mb-1">
                        {{ clientName }}
                    </h3>
                    <base-button
                        :disabled="deliveryUnits.length === 0"
                        type="primary"
                        @click="requestDelivery"
                    >
                        Request Delivery
                        <span v-if="deliveryUnits.length > 0" class="ml-1"
                            >({{ deliveryUnits.length }})</span
                        >
                    </base-button>
                </div>
            </div>
            <receipt-log-unit-table
                :receipt-log-id-column="true"
                :receipt-log-units="queriedData"
                :clear-selection="clearSelection"
                @selectionChange="deliveryUnits = $event"
            />
        </table-search-and-pagination>
    </div>
</template>
<script>
import moment from "moment-timezone";
import TableSearchAndPagination from "src/components/TableSearchAndPagination";
import { BaseSwitch } from "src/components/UI";
import ReceiptLogUnitTable from "src/modules/ReceiptLog/ReceiptLogDetail/_components/ReceiptLogUnitTable.vue";

export default {
    name: "ReceiptLogUnits",
    components: {
        TableSearchAndPagination,
        ReceiptLogUnitTable,
        BaseSwitch,
    },
    props: {
        receiptLogUnits: {
            type: Array,
            required: true,
        },
        clientName: {
            type: String,
            default: "",
        },
        currentPage: {
            type: Number,
            required: true,
        },
        perPage: {
            type: Number,
            default: 50,
        },
        routeQuery: {
            type: String,
            default: "",
        },
        showInStockOnly: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            queriedData: [],
            clearSelection: false,
            showRequestDeliveryModal: false,
            deliveryUnits: [],
        };
    },
    computed: {
        inStockOnly: {
            get() {
                return this.showInStockOnly;
            },
            set(toggle) {
                this.$emit("toggleInStockOnly", toggle);
            },
        },
    },
    watch: {
        deliveryUnits(units) {
            this.clearSelection = !units.length;
        },
    },
    methods: {
        formatDate(date) {
            if (date) {
                return moment(date).format("MM/DD/YYYY");
            }
            return "--";
        },
        requestDelivery() {
            this.$emit("requestDelivery", this.deliveryUnits);
            this.deliveryUnits = [];
        },
    },
};
</script>
